import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as API from "../../utils/apis";

const initialState = {
  adminDashboardTab: "",
  organizationDashboardTab: "",
  entitiesList: [],
  entitiesCount: 0,
  entitiesOffset: 0,
  entitiesLimit: 20,
  entitiesPage: 1,
  snackBarOpen: false,
  snackBarMessage: "",
  snackBarSeverity: "",
  drawerState: false,
  branchDrawerState: false,
  adminViewEntityDetail: {},
  adminViewBranchEntityDetail: {},
  adminGridDistrictSelect: "",
  adminGridCountySelect: "",
  rejectPayload: {},
  confirmationDialog:false,
  confirmationDialog2:false,
  confirmationBranchDialog:false,
  headerTitle:''
};

export const getEntitiesList = createAsyncThunk(
  "adminDashboard/getEntitiesList",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const offset = data ? data?.offset : 0;
      const limit = data ? data?.limit : 20;
      const res = await API.postDataApi(
        `Registration/GetEntitiesList?offset=${offset}&limit=${limit}`,
        data,
        token
      );

      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw error;
    }
  }
);

export const adminDashboardSlice = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {
    resetAdminDashBoard: (state) => {
      state = initialState;
    },
    setDrawerState: (state, action) => {
      state.drawerState = action.payload;
    },
    setBranchDrawerState: (state, action) => {
      state.branchDrawerState = action.payload;
    },
    setRejectPayload: (state, action) => {
      state.rejectPayload = action.payload;
    },
    setConfirmationDialog: (state, action) => {
      state.confirmationDialog = action.payload;
    },
    setConfirmationDialog2: (state, action) => {
      state.confirmationDialog2 = action.payload;
    },
    setConfirmationBranchDialog: (state, action) => {
      state.confirmationDialog = action.payload;
    },
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    },
    setAdminGridDistrictSelect: (state, action) => {
      state.adminGridDistrictSelect = action.payload;
    },
    setAdminGridCountySelect: (state, action) => {
      state.adminGridCountySelect = action.payload;
    },
    setAdminViewEntityDetail: (state, action) => {
      state.adminViewEntityDetail = action.payload;
    },
    setAdminViewBranchEntityDetail: (state, action) => {
      state.adminViewBranchEntityDetail = action.payload;
    },
    setAdminDashboardTab: (state, action) => {
      state.adminDashboardTab = action.payload;
    },
    setOrganizationDashboardTab: (state, action) => {
      state.organizationDashboardTab = action.payload;
    },
    setEntitiesOffset: (state, action) => {
      state.entitiesOffset = action.payload;
    },
    setEntitiesLimit: (state, action) => {
      state.entitiesLimit = action.payload;
    },
    setEntitiesPage: (state, action) => {
      state.entitiesPage = action.payload;
    },
    setSnackbarOpen: (state, action) => {
      state.snackBarOpen = action.payload;
    },
    setSnackbarMessage: (state, action) => {
      state.snackBarMessage = action.payload;
    },
    setSnackbarSeverity: (state, action) => {
      state.snackBarSeverity = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEntitiesList.pending, (state, action) => {
        state.loading = true;
        state.status = "in-progress";
      })
      .addCase(getEntitiesList.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.entitiesList = action.payload.obj.entityDetailsLists;
        state.entitiesCount = action.payload.obj.totalCount;
      })
      .addCase(getEntitiesList.rejected, (state, action) => {
        state.loading = false;
        state.status = "idle";
        state.entitiesList = [];
        state.entitiesCount = 0;
        state.entitiesOffset = 0;
        state.entitiesLimit = 20;
      });
  },
});

export const {
  resetAdminDashBoard,
  setAdminDashboardTab,
  setEntitiesOffset,
  setEntitiesLimit,
  setOrganizationDashboardTab,
  setEntitiesPage,
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity,
  setDrawerState,
  setBranchDrawerState,
  setAdminViewBranchEntityDetail,
  setAdminViewEntityDetail,
  setAdminGridDistrictSelect,
  setAdminGridCountySelect,
  setRejectPayload,
  setConfirmationDialog,
  setConfirmationDialog2,
  setHeaderTitle,
  setConfirmationBranchDialog
} = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
